import { DomainEvent } from "./DomainEvent";

export class OfferCreatedEvent extends DomainEvent {
    static eventType = 'offer_create';

    #userId;
    #productId;
    #offeredPrice;
    #currentPrice;
    #message;
    #offerId;
    #sellerId;
    #countrySeller;

    constructor(userId, productId, offeredPrice, currentPrice, message, offerId, sellerId, countrySeller) {
        super(OfferCreatedEvent.eventType);

        this.#userId = userId;
        this.#productId = productId;
        this.#offeredPrice = offeredPrice;
        this.#currentPrice = currentPrice;
        this.#message = message;
        this.#offerId = offerId;
        this.#sellerId = sellerId;
        this.#countrySeller = countrySeller;
    }

    get userId() {
        return this.#userId;
    }

    get productId() {
        return this.#productId;
    }

    get offeredPrice() {
        return this.#offeredPrice;
    }

    get currentPrice() {
        return this.#currentPrice;
    }

    get message() {
        return this.#message;
    }

    get offerId() {
        return this.#offerId;
    }

    get sellerId() {
        return this.#sellerId;
    }

    get countrySeller() {
        return this.#countrySeller;
    }
}